import React, { FC, memo, useEffect, useState, useRef } from 'react';
import { Droppable } from 'react-beautiful-dnd';
import { IDResource } from 'types';
import resourceTypes from 'utils/helpers/resourcesMap';
import { Scrollbars } from 'react-custom-scrollbars';
import _ from 'lodash';
import buttons from 'style/buttons.module.scss';
import HomeRoomListItem from './homeroomListItem';
import styles from '../index.module.scss';

interface HomeroomProps {
  dndId: number;
  handleMoveAll?: () => void;
  removeResourceFromSchedule?: (id: number) => void;
  anetapackHomeRoom?: IDResource[];
  errorCategory?: string;
  resources?: IDResource[];
  currentCategory: string;
  currentKidName?: string;
  anetaPackName?: string;
}
const Homeroom: FC<HomeroomProps> = ({
  dndId,
  handleMoveAll,
  resources,
  anetapackHomeRoom,
  removeResourceFromSchedule,
  currentCategory,
  errorCategory,
  currentKidName,
  anetaPackName,
}) => {
  const [activeCategory, setActiveCategory] = useState('math');
  const [errorLink, setErrorLink] = useState<IDResource>();
  const [isBluring, setIsBluring] = useState(true);
  const renderData = resources || anetapackHomeRoom;
  const categories = resourceTypes.map((rt, i) => ({
    id: i,
    label: rt.label,
  }));

  const scrollResourses = useRef<HTMLInputElement>(null);

  const onScroll = () => {
    if (scrollResourses && scrollResourses.current) {
      if (scrollResourses.current?.scrollLeft > 160) {
        setIsBluring(false);
      } else {
        setIsBluring(true);
      }
    }
  };
  useEffect(() => {
    if (errorCategory) {
      setActiveCategory(errorCategory);
      const errorElement = _.findLast(
        resources,
        (el) => el.type === errorCategory
      );
      setErrorLink(errorElement);
    } else {
      setErrorLink(undefined);
    }
  }, [errorCategory, resources]);

  useEffect(() => {
    setActiveCategory(currentCategory);
  }, [currentCategory]);

  return (
    <>
      <div className={styles.scheduleHeader}>
        <span className="message-title">
          {dndId === 1
            ? `${currentKidName}'s Anetapack
            Homeroom Resources`
            : `Shared Anetapack
            ${anetaPackName}'s Homeroom Resources`}
        </span>
        {dndId === 2 && (
          <button
            type="button"
            className={`${buttons.buttomPrimary} ${styles.buttonMoveAll}`}
            onClick={handleMoveAll}
          >
            Move All
          </button>
        )}
      </div>
      {isBluring && (
        <div
          className={
            dndId === 2
              ? `${styles.blur} ${styles.top}`
              : `${styles.blur} ${styles.top} ${styles.leftBlock}`
          }
        />
      )}
      <div
        ref={scrollResourses}
        onScroll={onScroll}
        className={styles.homeroomButtons}
      >
        {categories.map((el) => (
          <button
            className={`${
              el.label.toLocaleLowerCase() ===
              activeCategory.toLocaleLowerCase()
                ? styles.activeButton
                : ''
            }`}
            type="button"
            onClick={() => setActiveCategory(el.label.toLowerCase())}
            key={el.id}
          >
            {el.label}
          </button>
        ))}
      </div>
      <Scrollbars autoHeight autoHeightMax={324}>
        <Droppable droppableId={`${dndId}`} key={dndId}>
          {(provided, snapshot) => (
            <div
              {...provided.droppableProps}
              ref={provided.innerRef}
              className={styles.homeroomLinksList}
              style={
                dndId === 1
                  ? {
                      transition: 'all 0.1s ease-in',
                      background: snapshot.isDraggingOver ? '#f0f4f5' : '#fff',
                    }
                  : {}
              }
            >
              {renderData?.map(
                (el, i: number) =>
                  el.type?.toLocaleLowerCase() ===
                    activeCategory.toLocaleLowerCase() &&
                  el.ownerType !== 'event' && (
                    <div>
                      <HomeRoomListItem
                        removeResourceFromSchedule={removeResourceFromSchedule}
                        errorLink={errorLink}
                        data={el}
                        dndId={dndId}
                        idx={i}
                      />
                      {provided.placeholder}
                    </div>
                  )
              )}
            </div>
          )}
        </Droppable>
      </Scrollbars>
    </>
  );
};

export default memo(Homeroom);
